import withAemIntegration from "../../withAemIntegration";
import loadable from "../../utils/loadable";
const Component = loadable(() =>
  import("@lexus.com/ui/dist/modules/FeatureSet")
);

const ContentTilesEditConfig = {
  emptyLabel: "Content Tiles",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const ContentTiles = (props) => {
  return (
    <Component
      common={props}
      {...props}
      isContentTiles={true}
      alignText="center"
      stackedMode={props.mobileStacked}
    />
  );
};

export default withAemIntegration("lexus/components/content-tiles")(
  ContentTiles,
  ContentTilesEditConfig
);
